import React, { useState } from 'react';

import { CronJobName, CronJobPayload } from '../CronJobsCRUDForm.types';

import { converter } from './utils/converter';
import { synchronisationCronJobsSchema } from './utils/synchronisationCronJobsSchema';

import CronJobsCRUD from '../CronJobsCRUD';
import { SynchronisationCronJobsFormContent } from './SynchronisationCronJobsFormContent';

const SynchronisationCronJobs: React.FC = () => {
  const [selectedJobType, changeJobType] = useState<CronJobName>(
    'export-employee-hours'
  );
  const defaultValues: Partial<CronJobPayload> = {
    jobName: selectedJobType,
    importDefinitionId: '',
    period: '',
    cron: '',
    config: {
      tenantId: 'dzz',
      minusDays: '0',
      plusDays: '0'
    }
  };

  return (
    <CronJobsCRUD
      schema={synchronisationCronJobsSchema(selectedJobType)}
      defaultFormValues={synchronisationCronJobsSchema(selectedJobType).cast(
        defaultValues
      )}
      convertData={converter}
    >
      <SynchronisationCronJobsFormContent
        selectedJobType={selectedJobType}
        changeJobType={changeJobType}
      />
    </CronJobsCRUD>
  );
};

export default SynchronisationCronJobs;
